import { render, staticRenderFns } from "./MobileActivityDetail.vue?vue&type=template&id=ec8a7ee8"
import script from "./MobileActivityDetail.vue?vue&type=script&lang=js"
export * from "./MobileActivityDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports